export default __webpack_public_path__ + "static/media/DedicatedImage.75d45558.svg";